import {defineMessages} from 'react-intl';

const messages=defineMessages({
  app_name: 'Location de véhicules',
  dashboard: 'Dashboard',
  welcome_user : 'Bienvenue : {user}',
  intro_customer : 'A travers cette application, vous avez la possibilité de placer en ligne votre demande de location de véhicule {linkCreateService} {newLine}{newLine}Vous pouvez également visualiser les devis et factures reçues pour ces demande {linkViewReceipts}{newLine}{newLine}Gérer votre compte {linkManageCompanyDetails}{newLine}{newLine}Pour toutes questions et renseignements, veuillez nous contacter par ',
  intro_customer_no_account : 'A travers cette application, vous avez la possibilité de placer en ligne votre demande de location de véhicule de visualiser les devis et factures reçues pour ces demande {newLine}{newLine}Mais avant cela, nous vous demandons de mettre à jour votre compte {linkManageCompanyDetails}{newLine}{newLine}Pour toutes questions et renseignements, veuillez nous contacter par ',
  service_request_button: 'Demande de service',
  view_receipts_button: 'Factures',
  manage_account_button: 'Compte',
  about: 'À propos',
  about_content : 'Application pour la gestion de location de véhicules',
  page_not_found_demo: 'Page non trouvée',
  '404': '404',
  warning_404_message: '404 Page non trouvée',
  warning_404_description: 'Nous sommes désolé mais la page n\'existe pas.',
  confirm_quit_no_save : 'Attention! Êtes-vous sûr de quitter sans sauvegarder?',
  settings: 'Préférences',
  language: 'Langue',
  theme: 'Thème',
  responsive: 'Responsif',
  en: 'English',
  de: 'German',
  bs: 'Bosnian',
  ru: 'Russian',
  es: 'Spanish',
  fr: 'Français',
  dark: 'Foncé',
  light: 'Clair',
  ics: 'ICS',
  loading : 'Chargement en cours',
  dbError : 'Erreur de données',
  sign_out: 'Déconnection',
  sign_in: 'Connection',
  sign_up: 'Enregistrement',
  sign_in_with_google: 'Connexion avec Google',
  sign_in_with_facebook: 'Connexion avec Facebook',
  sign_in_with_twitter: 'Connexion avec Twitter',
  sign_in_with_github: 'Connexion avec Github',
  'link_with_google.com': 'Lien de Google',
  'link_with_facebook.com': 'Lien de Facebook',
  'link_with_twitter.com': 'Lien de Twitter',
  'link_with_github.com': 'Lien de Github',
  my_account: 'Mon compte',
  name: 'Nom',
  email: 'E-Mail',
  password: 'Mot de passe',
  new_password: 'Nouveau mot de passe',
  confirm_password: 'Confirmation du mot de passe',
  forgort_password: 'Mot de passe oublié?',
  reset_password: 'Reset Password',
  change_password: 'Changer mot de passe',
  change_photo: 'Changer photo',
  change_email: 'Changer E-Mail',
  reset_password_hint: 'Entrer votre E-Mail',
  save: 'Sauvegarder',
  delete_account: 'Effacer le compte',
  select_file: 'Selectionner fichier',
  cancel: 'Annuler',
  submit: 'Envoyer',
  delete: 'Effacer',
  ok: 'OK',
  delete_account_dialog_title: 'Effacer Account?',
  delete_account_dialog_message: 'Votre compte sera effacé et vous perderez toutes les informations!',
  email_not_verified: 'E-Mail non verifié!',
  email_verified: 'E-Mail est verifié',
  send_verification_email: 'Envoyer l\'E-Mail de vérification',
  send_verification_email_again: 'Ré-envoyer l\'E-Mail de vérification',
  tasks: 'Tâches',
  create_task: 'Créer tâche',
  edit_task: 'Modifier tâche',
  users: 'Utilisateurs',
  edit: 'Modifier',
  online: 'En ligne',
  offline: 'Hors-ligne',
  no_connection_warning: 'Pas de connection!',
  title_label: 'Titre',
  title_hint: 'Entrer le titre',
  no_connection: 'Pas de connection',
  delete_task_title: 'Effacer la tâche?',
  delete_task_message: 'La tâche va être effacée!',
  error: 'Erreur!',
  description_label: 'Description',
  description_hint: 'Entrer description',
  users_count_title: '{number} Utilisateurs',
  user_registrationg_graph_label: 'Utilisateurs registré',
  required: 'Requis',
  facebook: 'Facebook',
  github: 'Github',
  twitter: 'Twitter',
  phone: 'Téléphone',
  google: 'Google',
  facebook_color: '#303F9F',
  github_color: '#263238',
  twitter_color: '#36A2EB',
  phone_color: '#90A4AE',
  google_color: '#EA4335',
  password_color: '#4CAF50',
  load_more_label: 'Plus...',
  my_location: 'Mon lieu',
  select_user: 'Selectionner l\'utilisateur',
  operator_like_label: 'like',
  operator_notlike_label: 'not like',
  operator_equal_label: 'equal',
  operator_notequal_label: 'not equal',
  operator_novalue_label: 'no value',
  administration: 'Administration',
  roles: 'Rôles',
  grants: 'Accès',
  private: 'Privé',
  public: 'Publique',
  is_admin_label: 'Administrateur',
  select_field: 'Selectionner champ',
  sorting: 'Trier',
  filters: 'Filtres',
  filter: 'Filtrer',
  add_filter: 'Ajouter filtre',
  delete_filter: 'Effacer filtre',
  change_sort_orientation: 'Modifier le sens',
  enable_case_sensitivity: 'Case sensitivity',
  hint_autocomplete: 'Selectionnez',
  enter_query_text: 'Entrer texte',
  email_label: 'Email',
  close_filter: 'Fermer filtre',
  open_filter: 'Ouvrir filtre',
  select_operator: 'Selectionnez l\'operateur',
  not_match_found: 'Pas de résultats trouvé',
  edit_user: 'Modifier l\'utilisateur',
  user_label_search: 'Chercher utilisateur',
  document: 'Document',
  collection: 'Collection',
  vehicles : 'Véhicules',
  vehicle : 'Véhicule',
  action_label : 'Actions',
  create_vehicle : 'Ajout véhicule',
  edit_vehicle : 'Modification véhicule',
  licensePlate_hint : '1 IKJ 656',
  licensePlate_label : 'Plaque d\'immatriculation',
  brand_name_hint : ' Porsche',
  brand_name_label : 'Marque',
  vehicle_type_hint : 'Carrera',
  vehicle_type_label : 'Modèle',
  category_hint : '4*4 airco',
  category_label : 'Catégorie et options',
  defaultDriver_hint : 'Assam Ali - 012456221',
  defaultDriver_label : 'Conducteur habituel',
  pricePerDay_hint : '100000',
  pricePerDay_label : 'Prix demandé / jour',
  additionalPriceWithFuel_hint : '5000',
  additionalPriceWithFuel_label : 'Prix essence / jours / véhicule',
  kilometers_hint : '125001',
  kilometers_label : 'Kilométrage',
  vehicle_owner_title : 'Propriétaire du véhicule',
  vehicle_owner_hint : 'Ali Baba',
  vehicle_owner_label : 'Nom et prénom du propriétaire',
  vehicle_owner_phone_hint : '0245845521',
  vehicle_owner_phone_label : 'Numéro de téléphone',
  vehivle_no_owner : 'Véhicule en propre gestion',
  price_asked_hint : '80000',
  price_asked_label : 'Prix payé au propriétaire par jour',
  brand_and_type_label : 'Marque et modèle',
  available_label : 'Disponible',
  expense_date : 'Date',
  expense_price : 'Prix',
  expense_price_required : 'Renseignez le prix',
  expense_title : 'Intitulé',
  expense_service : 'Service',
  expense_total : 'Total : {total}',
  delete_expense_title : 'Effacer',
  delete_expense_message : 'Êtes-vous sûr de vouloir effacer la dépense?',
  expenses : 'Dépenses',
  services : 'Services',
  service_total_budget : 'Budget total pour la demande : {total}',
  service_total_paid :   'Montant total payé           : {total}',
  delete_service_title : 'Effacer service',
  delete_service_message : 'Êtes-vous sûr de vouloir effacer le service?',
  create_service : 'Créer service',
  edit_service : 'Modifier service',
  customer_name_label : 'Nom client',
  customer_name_hint : 'Ali Baba',
  service_title_label : 'Intitulé',
  service_title_hint : 'Marriage',
  service_adresse_label : 'Adresse',
  service_adresse_hint : 'Av. de la Paix',
  contact_person_label : 'Personne de contacte',
  contact_person_hint : 'Mohammed Boko',
  contact_person_phone_label : 'Téléphone',
  contact_person_phone_hint : '012456321',
  contact_person_email_label : 'e-Mail',
  contact_person_email_hint : 'mohammed@oms.td',
  service_date_start : 'Date de début',
  service_amount_vehicles : '# de véhicules /\n # assignés',
  service_confirmed : 'Confirmé',
  service_confirmed_yes : 'Oui',
  service_confirmed_no : 'Non',
  service_confirm_button : 'Confirmer',
  service_enterPayment_button : 'Enregistrer paiement',
  service_cancel_button : 'Annuler demande de service',
  service_cancelled_label : 'La demande de service est annulée',
  service_payed : 'Payé',
  service_details_subheader : 'Détails de la demande (une ligne par véhicule demandé)',
  add_service_details : 'Ajouter',
  remove_service_details : 'Effacer',
  service_details_title_label : 'Intitulé',
  service_details_title_hint : 'Mao',
  service_details_additionalData_label : 'Informatoins supplémentaires',
  service_details_additionalData_hint : 'Personne de contacte...',
  service_details_endDate_label : 'Date de fin',
  service_details_date_label : 'Date de début',
  service_details_date_hint : 'Date de début',
  service_details_additionalPriceWithFuel_hint : '50000',
  service_details_additionalPriceWithFuel_label : 'Prix demandé essence',
  service_details_amountDays_label : 'Nbre de jours',
  service_details_amountDays_hint : '10',
  service_details_amountDays_planned_label : 'Prévue',
  service_details_amountDays_planned_hint : 'Nbre de jour prévu',
  service_details_amountDays_real_label : 'Réelle',
  service_details_incidents_label : 'Incident',
  service_details_incidents_hint : 'Le nombre d\'incidents',
  service_details_fuel_label : 'Carburant',
  service_details_fuel_yes : 'Oui',
  service_details_fuel_no : 'Non',
  service_details_period_of_location : 'Durée de location',
  delete_service_detail_title : 'Effacer',
  delete_service_detail_message : 'Êtes-vous sûr de vouloir effacer cette ligne?',
  service_details_typeVehicleRequested_label : 'Type de véhicule demandé',
  service_details_typeVehicleRequested_hint : '4*4, airco, etc',
  service_details_vehicleProposed_label : 'Véhicule proposé',
  service_details_vehicleProposed_hint : 'BMW',
  service_details_priceProposedPerDay_label : 'Prix proposé/jour',
  service_details_pricePerDay_label : 'Prix/jour',
  service_details_priceProposedPerDay_hint : '',
  service_details_totalPriceProposed_label : 'Total ligne',
  service_details_driverAssigned_label : 'Chauffeur assigné',
  service_details_change_price_title : 'Modifier le prix proposé?',
  service_details_change_price_text : 'Voullez-vous modifier le prix proposé de {originalPrice} vers {newPrice}?',
  service_details_change_driver_title : 'Modifier le chauffeur',
  service_details_change_driver_text : 'Voullez-vous modifier le chauffeur assigné de {originalDriver} vers {newDriver}?',
  service_details_change_yes : 'OUI',
  service_details_change_no : 'NON',
  VehicleSelectionField_forAvailability_title : 'Sélection de véhicule pour le {fromDate} au {endDate}',
  VehicleSelectionField_title : 'Sélection de véhicule',
  vehicle_selector_no_row_serviceAssignment : 'Actuellement, pas assigné à un service',
  vehicle_selector_available_yes : 'OUI',
  vehicle_selector_available_no : 'NON',
  vehicle_selector_not_available : 'Non disponible',
  enter_service_payment_title : 'Enregistrement montant payé',
  enter_service_payment_message : ' ',
  service_payments_date_label : 'Date',
  service_payments_date_hint : ' ',
  service_payments_amount_label : 'Montant',
  service_payments_receipt_label : 'Facture',
  service_manage_receipts_button : 'Factures',
  service_manage_slips_button : 'Bons de livraison',
  manage_service_receipts_title : 'Factures',
  validation_required: 'Veuillez renseigner une valeur',
  validation_numeric: 'Veuillez renseigner un chiffre',
  validation_lessThan0: 'Veuillez renseigner un chiffre positif',
  doc_printing_date : 'N\'Djamena le {date}',
  doc_printing_date_label : 'Date',
  quotation_title : 'Devis N°D{number}',
  doc_printing_client_label : 'Destiné à',
  doc_printing_client_adres_label : 'Adresse',
  doc_printing_phone_label : 'Téléphone :',
  doc_printing_email_label : 'E-Mail :',
  doc_printing_title_label : 'Object :',
  doc_printing_total_price_no_tax_label : 'TOTAL HT',
  doc_printing_total_price_label : 'Prix total',
  doc_printing_way_of_payment_label : 'Règlement',
  printing_sonacoges_line1 : 'SONACOGES S.A.R.L',
  printing_sonacoges_line2 : 'BP : 1210',
  printing_sonacoges_line3 : 'N\'Djamena-Tchad',
  printing_sonacoges_line4 : 'Télephone : (+235) 66 24 24 85 / 66 36 13 13',
  printing_sonacoges_line5 : 'E-mail : contact@sonadatchad.com / sonacoges@gmail.com',
  receipts : 'Factures',
  create_receipt : 'Créer facture',
  edit_receipt : 'Modifier facture',
  receipt_id_label : 'Numéro',
  receipt_date_label : 'Date',
  receipt_title : 'Facture N°F{number}',
  receipt_payment_time_label : 'Échéance',
  receipt_total_label : 'Total',
  receipt_reference_client_label : 'Référence Bon de Commande',
  no_receipts : 'Pas de factures',
  delete_receipt_title : 'Effacer',
  delete_receipt_message : 'Êtes-vous sûr de vouloir effacer la facture?',
  service_payed_true : 'OUI',
  service_payed_false : 'NON',
  ReceiptSelectionField_title : 'Sélectionez une facture',
  ServiceSelectionField_title : 'Sélectionez un service',
  slips : 'Bon de livraison',
  create_slip : 'Créer Bon de livraison',
  edit_slip : 'Modifier Bon de livraison',
  slip_comments_label : 'Commentaires',
  slip_comments_hint : ' ',
  delete_slip_title : 'Effacer le Bon de livraison',
  delete_slip_message : 'Êtes-vous sûr de vouloir effacer le Bon de livraison?',
  slip_title : 'Bon de livraison N°BL{number}',
  companies: 'Companies',
  create_company: 'Détails de votre compte',
  edit_company: 'Détails de votre compte',
  delete_company_title: 'Effacer le compte client?',
  delete_company_message: 'Le compte client sera effacé!',
  full_name_label: 'Nom complet',
  full_name_hint: 'Saisir le nom complet',
  vat_label: 'Numéro taxes',
  vat_hint: 'Saisir le numéro de taxes',
  description_label: 'Description',
  description_hint: 'Saisir la description',
});

export default messages;



// WEBPACK FOOTER //
// ./src/locales/fr.js